import i18n from 'i18next';

export const PAYMENT_STATUS_OPTIONS = [
	{ name: i18n.t('payments:status.init'), value: 'init' },
	{ name: i18n.t('payments:status.pending'), value: 'pending' },
	{ name: i18n.t('payments:status.succeed'), value: 'succeed' },
	{ name: i18n.t('payments:status.failed'), value: 'failed' }
];
